function validateIsLowercase(value: string) {
  return value === value.toLowerCase() && value !== value.toUpperCase();
}

export function validateHasLowercaseCharacters(value: string) {
  return value && [...value].some(char => validateIsLowercase(char));
}
